import { render, staticRenderFns } from "./ItemPicker.vue?vue&type=template&id=1c5cadbe&scoped=true&"
import script from "./ItemPicker.vue?vue&type=script&lang=js&"
export * from "./ItemPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5cadbe",
  null
  
)

export default component.exports